import React, { useState } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";


const useStyles = makeStyles((theme) => ({
  labelSpan: {
    fontWeight: "500",
  },
  valueSpan: {
    width: "100%",
    textTransform: "uppercase",
  },
  nameSpan: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

const RenderOnlyField = (props) => {
  const { label, value, valueType, isMulti, ...rest } = props;
  const classes = useStyles();
  

 

 

  

  return (
    <Grid container item lg={12} direction="column">
      <Grid item lg={12}>
        <br/>
        <span className={classes.labelSpan}>{label}</span>
      </Grid>
      <Grid
        item
        lg={12}
        style={{
          wordWrap: "break-word",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
<ul>
  <li>This setup only applicable for notification type Email and Push Notification.</li>

  <li>Please ensure recipient has valid Email Adress and Estate information setup in their User Profile</li>
  
</ul>      </Grid>
    </Grid>
  );
};

RenderOnlyField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  valueType: PropTypes.string,
  isMulti: PropTypes.bool,
};

export default RenderOnlyField;
